import MovieOutlinedIcon from "@mui/icons-material/MovieOutlined";
import DataObjectOutlinedIcon from "@mui/icons-material/DataObjectOutlined";
import { CreativeJob } from "api/creativeStudio";
import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import ThemeColorSwatches from "./ThemeColorSwatches";

const linkStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  color: "inherit",
  fontSize: "12px",
};

const thumbnailStyle = {
  width: 48,
  height: 48,
  objectFit: "cover" as const,
  borderRadius: "6px",
};

/** The outputs of a job, by label. Links only once the job is done. */
const CreativeJobOutputs = ({ job }: { job: CreativeJob }) => {
  if (!job.outputs?.length) return <>-</>;

  if (job.status !== "done") {
    return (
      <DSTypography sx={{ fontSize: "12px", color: "text.secondary" }}>
        {job.status === "failed"
          ? "No outputs"
          : "The links show up here when it is done"}
      </DSTypography>
    );
  }

  return (
    <DSBox
      sx={{ display: "flex", flexDirection: "column", gap: 0.75, minWidth: 0 }}
    >
      {job.outputs.map((output) => (
        <DSBox
          key={output.url}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <DSBox sx={{ color: "primary.main" }}>
            <a
              href={output.url}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              {output.kind === "image" && (
                <img
                  src={output.url}
                  alt={output.label}
                  loading="lazy"
                  style={thumbnailStyle}
                />
              )}
              {output.kind === "video" && (
                <MovieOutlinedIcon sx={{ fontSize: 18 }} />
              )}
              {output.kind === "json" && (
                <DataObjectOutlinedIcon sx={{ fontSize: 18 }} />
              )}
              {output.label}
            </a>
          </DSBox>
          {output.kind === "json" && (
            <ThemeColorSwatches url={output.url} theme={job.klydoTheme} />
          )}
        </DSBox>
      ))}
    </DSBox>
  );
};

export default CreativeJobOutputs;
